export const layers = (zoom) => [
  {
    "id": "feature-label",
    "type": "symbol",
    "source": "features",
    "filter": ["!", ["has", "point_count"]],
    "layout": {
      "text-field": "{label}",
      "text-offset": [0, -1],
      "text-anchor": "bottom",
      "text-variable-anchor": ["bottom", "top", "left", "right",],
      "text-font": ["BarlowCondensed-Regular",],
      "text-size": 12 * zoom,
    },
    "paint": {
      "text-color": ["get", "color"],
      "text-halo-color": "#fff",
      "text-halo-width": 1
    },
  },
  {
    "id": "features-icon",
    "type": "symbol",
    "source": "features",
    "filter": ["!", ["has", "point_count"]],
    "layout": {
      "text-field": "{icons}",
      "text-font": ["icons",],
      "text-size": 20 * zoom,
      "text-letter-spacing": 0.1,
      "text-allow-overlap": true,
      "text-variable-anchor": ["top", "center", "left", "right", "top", 
        "bottom", "top-left", "top-right", "bottom-left", "bottom-right"],
      "text-max-width" : 3,
    },
    "paint": {
      "text-color": ["get", "color"],
      "text-halo-color": "#fff",
      "text-halo-width": 2,
    },
  },
  {
    "id": "features-clusters",
    "type": "circle",
    "source": "features",
    "filter": ["has", "point_count"],
    "paint": {
      "circle-color": "#294B62",
      "circle-radius": 10 * zoom,
      "circle-stroke-color": "#fff",
      "circle-stroke-width" : 3
    }
  },
  {
    "id": "feature-cluster-label",
    "type": "symbol",
    "source": "features",
    "filter": ["has", "point_count"],
    "layout": {
      "text-field": "{point_count_abbreviated}",
      "text-font": ["BarlowCondensed-SemiBold",],
      "text-size": 14 * zoom,
    },
    "paint":{
      "text-color": "#fff"
    }
  }
]
